<template>
    <van-popup v-model="show" mode="center" class="rd-dialog rd-confirm">
        <div class="content">
            <div class="title">
                {{ $t('lang.tips') }}
            </div>
            <div class="tip">
                {{ $t('DepositDetails.cancelOrderTips') }}
            </div>
            <div class="btns">
                <div class="btn" @click="close">
                    {{ $t('lang.cancel') }}
                </div>
                <div class="btn" @click="handleLogout">
                    {{ $t('lang.confirm') }}
                </div>
            </div>
        </div>
    </van-popup>
</template>

<script>
import { cancelUsdtDepositOrder } from '@/api/deposit'
import { Toast } from 'vant'
export default {
    data() {
        return {
            show: false
        }
    },
    props: {
        orderNo: {
            type: [String, Number],
            default: ''
        }
    },
    methods: {
        open() {
            this.show = true
        },
        close() {
            this.show = false
        },
        // 退出登录
        handleLogout() {
            const that = this
            cancelUsdtDepositOrder({ orderNo: that.orderNo }).then((res) => {
                if (res.code) return
                Toast(res.message)
                that.close()
                this.$emit('close')
            })
        }
    }
}
</script>

<style scoped lang="scss">
@import '@/common/styles/viriables.scss';

$deposit-confirm-popup-secondary-bg: rgba($font-title-color, .06);
$deposit-confirm-popup-secondary-text: rgba($font-title-color, .88);
.van-popup {
    background: transparent;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    overflow: visible;
}

.content {
    padding: .2rem .3rem .3rem;
    box-sizing: border-box;
    width: 6rem;
    background: $bg-popup-color;
    border-radius: .14rem;
    position: relative;
    color: $font-color;
    font-size: .24rem;
    text-align: center;
    padding-top: .5rem;

    .title {
        font-size: .3rem;
        color: $font-color;
        line-height: .7rem;
        height: .7rem;
        width: 4.2rem;
        position: absolute;
        left: calc(50% - 2.1rem);
        top: 0;
    }

    .tip {
        margin: .3rem 0 .65rem;
        height: .36rem;
        line-height: .36rem;
    }

    .btns {
        display: flex;
        justify-content: space-between;
        column-gap: .3rem;
        height: .7rem;
        line-height: .66rem;

        .btn {
            flex: 1;
            padding: 0 .1rem;
            border-radius: .14rem;
            cursor: pointer;
            color: $font-btn-color;

            &:first-child {
                background: $deposit-confirm-popup-secondary-bg;
                color: $deposit-confirm-popup-secondary-text;
            }

            &:last-child {
                background: $bg-btn-color;
            }
        }
    }
}
</style>
